// Ana görev toplu işlem çubuğu (Detaylı + Kolay + Profesyonel ortak).
// Yalnızca sunum — durum/işlem mantığı useTaskBulk hook'unda.
import { useState } from "react";
import { useIsPhone } from "../../lib/useResponsive";
import { Check, Pause, Play, AlertTriangle, Archive, Anchor, Trash2, X, ListChecks, FolderInput, ChevronDown, ChevronUp, Edit3, Ban, BellOff, Bell, UserPlus, GripVertical, Clock, Copy, Link2, Share2, Lock, FileDown } from "lucide-react";
import { flattenCategoryOptions } from "../../lib/categoryTree";
import { REMINDER_DAY_CHOICES } from "../../lib/taskHelpers";
import { ReassignModal } from "./ReassignModal";
import { CopyTaskModal } from "./CopyTaskModal";
import { LinkTasksModal } from "./LinkTasksModal";
import { ShareTaskModal } from "./ShareTaskModal";
import { LockConfigModal } from "./LockConfigModal";
import { printTasks, exportTasksExcel, exportTasksWord } from "../../lib/taskExport";
import { RenkSecici } from "./TaskColor";

const BTN = "hud-text px-1.5 py-0.5 rounded border shrink-0 disabled:opacity-40 flex items-center gap-1 transition-colors";

// AŞAMA 3A — "Hatırlat" hazır seçenekleri (kart menüsündeki değerlerle aynı).
const REMINDER_OFFSETS = [
  { label: "30 dakika sonra", offset: 30 * 60 * 1000, intervalMin: 30 },
  { label: "1 saat sonra", offset: 60 * 60 * 1000, intervalMin: 60 },
  { label: "3 saat sonra", offset: 3 * 60 * 60 * 1000, intervalMin: 180 },
  { label: "1 gün sonra", offset: 24 * 60 * 60 * 1000, intervalMin: 1440 },
  { label: "1 hafta sonra", offset: 7 * 24 * 60 * 60 * 1000, intervalMin: 10080 },
];

const MENU_WRAP = "absolute left-0 top-full mt-1 z-[60] w-56 max-h-64 overflow-y-auto scrollbar-sertex rounded-md border border-violet-400/40 bg-sertex-surface shadow-xl py-1";
const MENU_ITEM = "w-full text-left px-3 py-1.5 text-xs font-mono text-sertex-text hover:bg-violet-500/15 hover:text-violet-100 whitespace-pre truncate";

export const TaskBulkBar = ({ count = 0, testPrefix = "task-bulk", categories = [], tasks = [], ids = [], onSelectAll, onClear, onCancel, onAction, onRefresh }) => {
  const dis = !count;
  const [moveOpen, setMoveOpen] = useState(false);
  const [remOpen, setRemOpen] = useState(false);
  const [dueOpen, setDueOpen] = useState(false);
  const [reassignOpen, setReassignOpen] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [linkOpen, setLinkOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [lockOpen, setLockOpen] = useState(false);
  const [expOpen, setExpOpen] = useState(false);
  const [renkOpen, setRenkOpen] = useState(false);
  // TELEFON: çubuk varsayılan olarak KATLANMIŞ gelir; aksi hâlde eylem
  // düğmeleri 700 px'i aşıp görev listesinin tamamını örtüyordu.
  const telefon = useIsPhone();
  const [eylemlerAcik, setEylemlerAcik] = useState(false);
  const katli = telefon && !eylemlerAcik;

  const secili = ids.map((id) => tasks.find((t) => t.id === id)).filter(Boolean);
  const catMap = Object.fromEntries((categories || []).map((c) => [c.id, c.name]));
  const disaAktar = async (kind) => {
    setExpOpen(false);
    if (!secili.length) return;
    if (kind === "print") printTasks(secili, catMap, {});
    else if (kind === "excel") exportTasksExcel(secili, catMap, {});
    else if (kind === "word") await exportTasksWord(secili, catMap, { heading: `${secili.length} seçili görev` });
  };
  const catOpts = [{ id: "", label: "Kolsuz" }, ...flattenCategoryOptions(categories || [])];
  const hasCats = (categories || []).length > 0;

  const doMove = (id) => {
    setMoveOpen(false);
    onAction("move", { categoryId: id || null });
  };

  return (
    <div
      className="sticky top-0 z-30 flex flex-wrap items-center gap-1.5 mb-2 p-1.5 rounded-md border border-violet-400/50 bg-sertex-bg/95 backdrop-blur-sm shadow-lg shadow-violet-900/30"
      data-testid={`${testPrefix}-bar`}
    >
      <span className="hud-text text-violet-200 flex items-center gap-1 mr-1" data-testid={`${testPrefix}-count`}>
        <ListChecks className="h-3 w-3" /> {count} GÖREV SEÇİLİ
      </span>
      <button onClick={onSelectAll} data-testid={`${testPrefix}-selectall`} className={`${BTN} border-violet-400/40 text-violet-200 hover:bg-violet-500/20`}>Tümünü Seç</button>
      <button onClick={onClear} data-testid={`${testPrefix}-clear`} className={`${BTN} border-white/15 text-sertex-textMuted hover:text-sertex-text`}>Temizle</button>
      {telefon && (
        <button
          onClick={() => setEylemlerAcik((v) => !v)}
          data-testid={`${testPrefix}-toggle`}
          className={`${BTN} border-violet-400/40 text-violet-200 hover:bg-violet-500/20`}
        >
          {eylemlerAcik ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />} İşlemler
        </button>
      )}
      {telefon && (
        <button onClick={onCancel} data-testid={`${testPrefix}-cancel`} className={`${BTN} border-white/15 text-sertex-textMuted hover:text-sertex-text ml-auto`}><X className="h-3 w-3" /> Vazgeç</button>
      )}
      {!katli && (
      <div
        className={telefon
          ? "w-full flex flex-wrap items-center gap-1.5 pt-1.5 mt-1 border-t border-violet-400/20 max-h-[42vh] overflow-y-auto scrollbar-sertex"
          : "contents"}
        data-testid={`${testPrefix}-actions`}
      >
      <span className="w-px h-4 bg-white/10 mx-0.5" />
      <button disabled={dis} onClick={() => onAction("done")} data-testid={`${testPrefix}-done`} className={`${BTN} border-emerald-400/40 text-emerald-300 hover:bg-emerald-500/15`}><Check className="h-3 w-3" /> Tamamla</button>
      <button disabled={dis} onClick={() => onAction("paused")} data-testid={`${testPrefix}-paused`} className={`${BTN} border-yellow-400/40 text-yellow-300 hover:bg-yellow-500/15`}><Pause className="h-3 w-3" /> Beklet</button>
      <button disabled={dis} onClick={() => onAction("pending")} data-testid={`${testPrefix}-pending`} className={`${BTN} border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10`}><Play className="h-3 w-3" /> Aktif</button>
      <button disabled={dis} onClick={() => onAction("overdue")} data-testid={`${testPrefix}-overdue`} className={`${BTN} border-rose-400/40 text-rose-300 hover:bg-rose-500/15`}><AlertTriangle className="h-3 w-3" /> Tarihi geçti</button>
      <button disabled={dis} onClick={() => onAction("edit")} data-testid={`${testPrefix}-edit`} className={`${BTN} border-violet-400/40 text-violet-200 hover:bg-violet-500/20`}><Edit3 className="h-3 w-3" /> Düzenle</button>
      <button disabled={dis} onClick={() => onAction("archive")} data-testid={`${testPrefix}-archive`} className={`${BTN} border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10`}><Archive className="h-3 w-3" /> Arşivle</button>
      {hasCats && (
        <div className="relative shrink-0">
          <button disabled={dis} onClick={() => setMoveOpen((v) => !v)} data-testid={`${testPrefix}-move`} className={`${BTN} border-violet-400/40 text-violet-200 hover:bg-violet-500/20`}>
            <FolderInput className="h-3 w-3" /> İş Koluna Taşı <ChevronDown className="h-3 w-3 opacity-70" />
          </button>
          {moveOpen && !dis && (
            <>
              <div className="fixed inset-0 z-[59]" onClick={() => setMoveOpen(false)} data-testid={`${testPrefix}-move-backdrop`} />
              <div
                className="absolute left-0 top-full mt-1 z-[60] w-56 max-h-64 overflow-y-auto scrollbar-sertex rounded-md border border-violet-400/40 bg-sertex-surface shadow-xl py-1"
                data-testid={`${testPrefix}-move-menu`}
              >
                {catOpts.map((c) => (
                  <button
                    key={c.id || "__none__"}
                    onClick={() => doMove(c.id)}
                    data-testid={`${testPrefix}-move-opt-${c.id || "none"}`}
                    className="w-full text-left px-3 py-1.5 text-xs font-mono text-sertex-text hover:bg-violet-500/15 hover:text-violet-100 whitespace-pre truncate"
                  >
                    {c.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
      <button disabled={dis} onClick={() => onAction("pin")} data-testid={`${testPrefix}-pin`} className={`${BTN} border-amber-400/40 text-amber-300 hover:bg-amber-500/15`}><Anchor className="h-3 w-3" /> Sabitle</button>
      <button disabled={dis} onClick={() => onAction("unpin")} data-testid={`${testPrefix}-unpin`} className={`${BTN} border-white/15 text-sertex-textMuted hover:text-amber-200`}><Anchor className="h-3 w-3" /> Sabiti kaldır</button>
      <button disabled={dis} onClick={() => onAction("delete")} data-testid={`${testPrefix}-delete`} className={`${BTN} border-rose-400/40 text-rose-300 hover:bg-rose-500/15`}><Trash2 className="h-3 w-3" /> Sil</button>

      {/* AŞAMA 3A — tek değerli toplu işlemler */}
      <button disabled={dis} onClick={() => onAction("cancel")} data-testid={`${testPrefix}-cancel-tasks`} className={`${BTN} border-rose-400/40 text-rose-300 hover:bg-rose-500/15`}><Ban className="h-3 w-3" /> İptal Et</button>
      <button disabled={dis} onClick={() => onAction("digest-mute")} data-testid={`${testPrefix}-digest-mute`} className={`${BTN} border-amber-400/40 text-amber-200 hover:bg-amber-500/15`}><BellOff className="h-3 w-3" /> Sabah Özetinden Çıkar</button>
      <button disabled={dis} onClick={() => onAction("reset-size")} data-testid={`${testPrefix}-reset-size`} className={`${BTN} border-white/15 text-sertex-textMuted hover:text-sertex-text`}><GripVertical className="h-3 w-3" /> Boyutu Sıfırla</button>
      <button disabled={dis} onClick={() => setReassignOpen(true)} data-testid={`${testPrefix}-reassign`} className={`${BTN} border-purple-400/40 text-purple-200 hover:bg-purple-500/20`}><UserPlus className="h-3 w-3" /> Devret</button>

      <div className="relative shrink-0">
        <button disabled={dis} onClick={() => setRemOpen((v) => !v)} data-testid={`${testPrefix}-reminder`} className={`${BTN} border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10`}>
          <Bell className="h-3 w-3" /> Hatırlat <ChevronDown className="h-3 w-3 opacity-70" />
        </button>
        {remOpen && !dis && (
          <>
            <div className="fixed inset-0 z-[59]" onClick={() => setRemOpen(false)} />
            <div className={MENU_WRAP} data-testid={`${testPrefix}-reminder-menu`}>
              {REMINDER_OFFSETS.map((o) => (
                <button
                  key={o.intervalMin}
                  onClick={() => {
                    setRemOpen(false);
                    onAction("reminder", {
                      reminderAt: new Date(Date.now() + o.offset).toISOString(),
                      intervalMin: o.intervalMin,
                    });
                  }}
                  data-testid={`${testPrefix}-reminder-opt-${o.intervalMin}`}
                  className={MENU_ITEM}
                >
                  {o.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="relative shrink-0">
        <button disabled={dis} onClick={() => setDueOpen((v) => !v)} data-testid={`${testPrefix}-due-soon`} className={`${BTN} border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10`}>
          <Clock className="h-3 w-3" /> Yaklaşan Uyarısı <ChevronDown className="h-3 w-3 opacity-70" />
        </button>
        {dueOpen && !dis && (
          <>
            <div className="fixed inset-0 z-[59]" onClick={() => setDueOpen(false)} />
            <div className={MENU_WRAP} data-testid={`${testPrefix}-due-soon-menu`}>
              <button onClick={() => { setDueOpen(false); onAction("due-soon", { patch: { reminder_days: null, reminder_disabled: false } }); }} data-testid={`${testPrefix}-due-soon-opt-default`} className={MENU_ITEM}>Varsayılan (hiyerarşi)</button>
              {REMINDER_DAY_CHOICES.map((d) => (
                <button key={d} onClick={() => { setDueOpen(false); onAction("due-soon", { patch: { reminder_days: d, reminder_disabled: false } }); }} data-testid={`${testPrefix}-due-soon-opt-${d}`} className={MENU_ITEM}>{d} gün önce</button>
              ))}
              <button onClick={() => { setDueOpen(false); onAction("due-soon", { patch: { reminder_disabled: true } }); }} data-testid={`${testPrefix}-due-soon-opt-off`} className={MENU_ITEM}>Kapalı</button>
            </div>
          </>
        )}
      </div>

      {reassignOpen && (
        <ReassignModal
          task={{ id: "__bulk__", title: `${count} görev` }}
          bulkCount={count}
          onClose={() => setReassignOpen(false)}
          onSave={(userId) => { setReassignOpen(false); onAction("reassign", { userId }); }}
        />
      )}

      {/* AŞAMA 3B — seçenek penceresi gerektiren toplu işlemler */}
      <button disabled={dis} onClick={() => setRenkOpen(true)} data-testid={`${testPrefix}-renk`} className={`${BTN} border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10`}>Renk</button>
      <button disabled={dis} onClick={() => setCopyOpen(true)} data-testid={`${testPrefix}-copy`} className={`${BTN} border-sky-400/40 text-sky-200 hover:bg-sky-500/15`}><Copy className="h-3 w-3" /> Kopyala</button>
      <button disabled={dis || count < 2} onClick={() => setLinkOpen(true)} data-testid={`${testPrefix}-link`} className={`${BTN} border-teal-400/40 text-teal-200 hover:bg-teal-500/15`}><Link2 className="h-3 w-3" /> Görevleri Bağla</button>
      <button disabled={dis} onClick={() => setShareOpen(true)} data-testid={`${testPrefix}-share`} className={`${BTN} border-emerald-400/40 text-emerald-200 hover:bg-emerald-500/15`}><Share2 className="h-3 w-3" /> Paylaş</button>
      <button disabled={dis} onClick={() => setLockOpen(true)} data-testid={`${testPrefix}-locks`} className={`${BTN} border-yellow-400/40 text-yellow-200 hover:bg-yellow-500/15`}><Lock className="h-3 w-3" /> Kilit Ayarları</button>

      <div className="relative shrink-0">
        <button disabled={dis} onClick={() => setExpOpen((v) => !v)} data-testid={`${testPrefix}-export`} className={`${BTN} border-white/20 text-sertex-text hover:bg-white/10`}>
          <FileDown className="h-3 w-3" /> Dışa Aktar <ChevronDown className="h-3 w-3 opacity-70" />
        </button>
        {expOpen && !dis && (
          <>
            <div className="fixed inset-0 z-[59]" onClick={() => setExpOpen(false)} />
            <div className={MENU_WRAP} data-testid={`${testPrefix}-export-menu`}>
              <button onClick={() => disaAktar("print")} data-testid={`${testPrefix}-export-print`} className={MENU_ITEM}>Yazdır ({secili.length})</button>
              <button onClick={() => disaAktar("excel")} data-testid={`${testPrefix}-export-excel`} className={MENU_ITEM}>Excel ({secili.length})</button>
              <button onClick={() => disaAktar("word")} data-testid={`${testPrefix}-export-word`} className={MENU_ITEM}>Word ({secili.length})</button>
            </div>
          </>
        )}
      </div>

      {renkOpen && <RenkSecici hedefler={ids.map((id) => ({ task_id: id }))} mevcut={null} onClose={() => setRenkOpen(false)} testPrefix={`${testPrefix}-renk`} />}
      {copyOpen && (
        <CopyTaskModal
          task={secili[0] || { id: "__bulk__", title: `${count} görev`, subtasks: [] }}
          bulkCount={count}
          onClose={() => setCopyOpen(false)}
          onBulkConfirm={(copyOpts) => { setCopyOpen(false); onAction("duplicate", { copyOpts }); }}
        />
      )}
      {linkOpen && (
        <LinkTasksModal
          candidateTasks={secili}
          preselectedIds={ids}
          onClose={() => setLinkOpen(false)}
          onSaved={() => { setLinkOpen(false); onRefresh?.(); onCancel?.(); }}
        />
      )}
      {shareOpen && (
        <ShareTaskModal
          task={{ id: "__bulk__", title: `${count} görev`, shared_with: [] }}
          bulkCount={count}
          onClose={() => setShareOpen(false)}
          onBulkConfirm={(shares, notify) => {
            setShareOpen(false);
            onAction("shares", {
              shares,
              notify,
              sharesFor: (id) => tasks.find((t) => t.id === id)?.shared_with || [],
            });
          }}
        />
      )}
      {lockOpen && (
        <LockConfigModal
          task={{ id: "__bulk__", title: `${count} görev`, lock_flags: {} }}
          bulkCount={count}
          onClose={() => setLockOpen(false)}
          onBulkConfirm={(flags, requiresOtp) => { setLockOpen(false); onAction("locks", { flags, requiresOtp }); }}
        />
      )}
      </div>
      )}
      {!telefon && (
        <button onClick={onCancel} data-testid={`${testPrefix}-cancel`} className={`${BTN} border-white/15 text-sertex-textMuted hover:text-sertex-text ml-auto`}><X className="h-3 w-3" /> Vazgeç</button>
      )}
    </div>
  );
};

export default TaskBulkBar;
